import React from "react";

export default function Menu() {
  return (
    <div className="menuContainer primary white">
      <div className="menuExchange">EXCHANGE</div>
      <div className="menuSymbol">SYMBOL</div>
      <div className="menuExpiry">EXPIRY</div>
      <div className="menuBuyPrice">NET QTY</div>
      <div className="menuBuyQty">RATE</div>
      <div className="menuSellQty">B/S</div>
      <div className="menuSellQty">BALANCE</div>
      <div className="menuSellQty">VOLUME</div>
      <div className="menuSymbol">TYPE</div>
      <div className="menuSellQty">COMMISSION</div>
      <div className="menuOpen">P/L</div>
      <div className="menuLtt">OTHER</div>
      <div className="menuLtt">DATE</div>
    </div>
  );
}
